import { render, staticRenderFns } from "./SpatialActsPopupTable.vue?vue&type=template&id=5e0f7676&scoped=true&"
import script from "./SpatialActsPopupTable.vue?vue&type=script&lang=js&"
export * from "./SpatialActsPopupTable.vue?vue&type=script&lang=js&"
import style0 from "./SpatialActsPopupTable.vue?vue&type=style&index=0&id=5e0f7676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f7676",
  null
  
)

export default component.exports